var Klipsch = typeof Klipsch === "object" ? Klipsch : {}; Klipsch["ecommerce"] =
 (function(modules) { 
 	var installedModules = {};
 	function __webpack_require__(moduleId) {
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 		module.l = true;
 		return module.exports;
 	}
 	__webpack_require__.m = modules;
 	__webpack_require__.c = installedModules;
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
 	__webpack_require__.p = "";
 	return __webpack_require__(__webpack_require__.s = 103);
 })
 ({

 103:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "refreshProductInfo", function() { return refreshProductInfo; });
 var _modules_ecommerce_MagentoFrontendApi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(104);
 var _modules_ecommerce_pricing_ux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(105);
 var _modules_ecommerce_add_to_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(111);




let api;
let baseUrl;
let baseEcommerceUrl;
let storeName;
let baseApiUri;
const magentoInit = () => {
  baseUrl = window.__klipsch.cmsBaseUrl;
  baseEcommerceUrl = window.__klipsch.cmsBaseEcommUrl;
  Klipsch.ecommerceUs = Klipsch.ecommerceUs || {};
  Klipsch.ecommerceUs.Magento = {
    baseUrl: window.__klipsch.cmsBaseUrl,
    baseEcommerceUrl: window.__klipsch.cmsBaseEcommUrl
  };
  storeName = window.__klipsch.storeName;
  baseApiUri = 'graphql/';
  api = new _modules_ecommerce_MagentoFrontendApi__WEBPACK_IMPORTED_MODULE_0__["default"](baseUrl, baseApiUri, baseEcommerceUrl, storeName);
  Object(_modules_ecommerce_pricing_ux__WEBPACK_IMPORTED_MODULE_1__["loadAndDisplayPricing"])(api);
  Object(_modules_ecommerce_add_to_cart__WEBPACK_IMPORTED_MODULE_2__["default"])(api);
};
magentoInit();

const refreshProductInfo = () => {
  Object(_modules_ecommerce_pricing_ux__WEBPACK_IMPORTED_MODULE_1__["processEcommElements"])();
  Object(_modules_ecommerce_pricing_ux__WEBPACK_IMPORTED_MODULE_1__["loadAndDisplayPricing"])(api);
  Object(_modules_ecommerce_add_to_cart__WEBPACK_IMPORTED_MODULE_2__["default"])(api);
};

 }),

 104:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "default", function() { return MagentoFrontendApi; });
const status = response => {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  }
  return Promise.reject(new Error(response.statusText));
};
const json = response => {
  return response.json();
};

class MagentoFrontendApi {
  constructor(baseUrl, baseApiUri, baseEcommerceUrl, storeName) {
    this.baseUrl = baseUrl;
    this.baseApiUri = baseApiUri;
    this.baseEcommerceUrl = baseEcommerceUrl;
    this.cartData = null;
    this.cartQty = 0;
    this.currentCart = null;
    this.fullApiUrl = "".concat(this.baseEcommerceUrl).concat(this.baseApiUri);
    this.storeName = storeName;
    this.currency = 'USD';
  }

  addToCart(data, cartId) {
    let bodyString = JSON.stringify(data);
    const reqUrl = new URL("".concat(this.fullApiUrl));
    bodyString = bodyString.replace(/"([^"]+)":/g, '$1:');
    return fetch(reqUrl, {
      method: 'POST',
      credentials: 'include',
      headers: [['Content-Type', 'application/json'], ['Store', this.storeName]],
      body: JSON.stringify({
        query: "\n          mutation {\n            addSimpleProductsToCart(\n              input: {\n                cart_id: \"".concat(cartId, "\"\n                cart_items: ").concat(bodyString, "\n              }\n            ) {\n              cart {\n                id\n                items {\n                  id\n                  product {\n                    name\n                    sku\n                  }\n                  quantity\n                  prices {\n                    price {\n                      value\n                    }\n                  }\n                }\n              }\n            }\n          }\n        ")
      })
    }).then(status).then(json).then(responseData => {
      this.currentCart = responseData;
      this.cartData = this.currentCart.data.addSimpleProductsToCart.cart;
    }).catch(error => console.warn(error));
  }

  getCart() {
    const reqUrl = new URL("".concat(this.fullApiUrl));
    return fetch(reqUrl, {
      method: 'POST',
      credentials: 'include',
      headers: [['Content-Type', 'application/json'], ['Store', this.storeName]],
      body: JSON.stringify({
        query: "\n          query PassportCart {\n            passportCart {\n              id\n              items {\n                id\n                product {\n                  name\n                  sku\n                }\n                quantity\n                prices {\n                  price {\n                    value\n                  }\n                }\n              }\n            }\n          }\n        "
      })
    }).then(status).then(json).then(responseData => {
      this.currentCart = responseData;
      this.cartData = this.currentCart.data.passportCart;
    }).catch(error => console.warn(error));
  }

  getProductInfo(data) {
    const dataString = JSON.stringify(data);
    const reqUrl = new URL("".concat(this.fullApiUrl));
    return fetch(reqUrl, {
      method: 'POST',
      credentials: 'include',
      headers: [['Content-Type', 'application/json'], ['Store', this.storeName]],
      body: JSON.stringify({
        query: "\n          {\n            products(pageSize: 500, filter: {sku: {in: ".concat(dataString, "}}) {\n              items {\n                name\n                sku\n                stock_status\n                sqty\n                only_x_left_in_stock\n                special_price\n                backorder_status\n                is_pre_order\n                pre_order_label\n                affirm_product_promo_id\n                price_range {\n                  maximum_price {\n                    discount {\n                      amount_off\n                      percent_off\n                    }\n                    regular_price {\n                      value\n                      currency\n                    }\n                    final_price {\n                      value\n                      currency\n                    }\n                  }\n                }\n              }\n            }\n          }\n        ")
      })
    }).then(status).then(json).catch(error => console.warn(error));
  }
}

 }),

 105:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "processEcommElements", function() { return processEcommElements; });
 __webpack_require__.d(__webpack_exports__, "loadAndDisplayPricing", function() { return loadAndDisplayPricing; });
 var _currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);
 var _affirm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(107);
 var _MagentoOosNotify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(108);
 var _placeholder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(109);
 var _availability__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(110);






let API;
const allBundles = [];
const affirmProductPromoIdCode = 'affirm_product_promo_id';

const allSkus = [];
let allPricingElements;
let allCardFlagElements;
let allAtcButtonElements;
let allAtcIconElements;
let allOosFormElements;
let uniqueSkus;
const processEcommElements = () => {
  allPricingElements = document.querySelectorAll('[data-ecomm-show="price"]');

  allCardFlagElements = document.querySelectorAll('[data-ecomm-show="card_flag"]');

  allAtcButtonElements = document.querySelectorAll('[data-ecomm-show="atc_button"]');

  allAtcIconElements = document.querySelectorAll('[data-ecomm-show="atc_icons"]');

  allOosFormElements = document.querySelectorAll('[data-ecomm-show="oos_form"]');
  allPricingElements.forEach(ele => {
    const dataSku = ele.dataset.ecommSku;
    const dataBundle = ele.dataset.ecommBundle;
    if (dataSku !== '') {
      allSkus.push(dataSku);
    }
    if (!dataBundle || dataBundle === '0') return;
    const bundleItems = ele.dataset.ecommItems;

    allBundles.push(bundleItems);
    const parsedDataBundle = JSON.parse(bundleItems);
    parsedDataBundle.items.forEach(data => {
      allSkus.push(data.item_id);
    });
  });


  const allUniqueSkus = new Set();
  uniqueSkus = allSkus.filter(element => {
    const isDuplicate = allUniqueSkus.has(element);
    allUniqueSkus.add(element);
    if (!isDuplicate) return true;
    return false;
  });
};
processEcommElements();
const initOosSignupUi = (product, baseEcommerceUrl, baseApiUri, storeName) => {
  const {
    sku
  } = product;
  const signupUiOptions = {
    baseEcommerceUrl,
    baseApiUri,
    sku,
    eleId: "out-of-stock-notify-".concat(sku),
    storeName
  };
  Object(_MagentoOosNotify__WEBPACK_IMPORTED_MODULE_2__["default"])(signupUiOptions);
};
const activateAtcButton = (product, buttonElement) => {
  const buttonEle = buttonElement;
  let showButton = true;
  if (product !== undefined) showButton = Object(_availability__WEBPACK_IMPORTED_MODULE_4__["isPurchaseable"])(product);
  if (!showButton) {
    buttonEle.style.display = 'none';
    return showButton;
  }

  buttonEle.removeAttribute('disabled');
  buttonEle.style.display = 'block';
  return showButton;
};
const activateOosForm = (product, formElement) => {
  const formEle = formElement.querySelector('form');
  let showForm = true;
  if (product !== undefined) showForm = Object(_availability__WEBPACK_IMPORTED_MODULE_4__["isOutOfStock"])(product) && !Object(_availability__WEBPACK_IMPORTED_MODULE_4__["isOnBackorder"])(product);
  if (showForm) formEle.style.display = 'block';else formEle.style.display = 'none';
  return showForm;
};
const activateAtcIcons = (product, iconSetElement) => {
  const iconSetEle = iconSetElement;
  let showIconSet = true;
  if (product !== undefined) showIconSet = Object(_availability__WEBPACK_IMPORTED_MODULE_4__["isPurchaseable"])(product);
  if (showIconSet) iconSetEle.classList.add('ecommerce-active');else iconSetEle.classList.remove('ecommerce-active');
  return showIconSet;
};
const buildPricingElement = (pricingElement, finalPriceAmount, basePriceAmount) => {
  const pricingEle = pricingElement;
  const finalPriceDisplay = Object(_currency__WEBPACK_IMPORTED_MODULE_0__["numberToDollarString"])(finalPriceAmount);
  const basePriceDisplay = Object(_currency__WEBPACK_IMPORTED_MODULE_0__["numberToDollarString"])(basePriceAmount);
  if (finalPriceDisplay === '') return;

  const sellsIn = pricingElement.dataset.ecommSellsIn ? pricingElement.dataset.ecommSellsIn : '';
  let displayPriceEle = '';
  if (finalPriceDisplay !== basePriceDisplay) {
    const percentOff = Math.round(Math.abs((finalPriceAmount - basePriceAmount) / basePriceAmount * 100));
    displayPriceEle = "\n      <span class=\"product-display-price\">\n        <span class=\"product-original-price\">\n          <span class=\"strikethrough-price\">".concat(basePriceDisplay, "</span>\n        </span>\n        ").concat(finalPriceDisplay, "\n      </span> ").concat(sellsIn, "\n      <div class=\"product-sale-info\">\n          (").concat(percentOff, "% OFF)\n      </div>\n    ");
  } else {
    displayPriceEle = "\n      <span class=\"product-display-price\">\n        ".concat(finalPriceDisplay, "\n      </span> ").concat(sellsIn, "\n    ");
  }
  pricingEle.innerHTML = displayPriceEle;
};
const buildAvailabilityElement = product => {
  const availabilityText = Object(_availability__WEBPACK_IMPORTED_MODULE_4__["showAvailText"])(product);
  const availabilityElements = document.querySelectorAll(".product-avail-text[data-partnumber=\"".concat(product.sku, "\"]"));
  availabilityElements.forEach(element => {
    const ele = element;
    ele.innerHTML = availabilityText;
  });
};
const buildCardFlagElement = (cardFlagElement, finalPriceAmount, basePriceAmount) => {
  const cardFlagEle = cardFlagElement;
  if (finalPriceAmount === basePriceAmount) return;
  const percentOff = Math.round(Math.abs((finalPriceAmount - basePriceAmount) / basePriceAmount * 100));
  cardFlagEle.innerHTML = "".concat(percentOff, "% Off");
  cardFlagEle.classList.add('card-flag--active');
  cardFlagEle.style.display = 'block';
};
const updateElementEcommItemsPricing = (element, productData) => {
  const ecommItems = JSON.parse(element.dataset.ecommItems);
  const newEcommItems = [];
  ecommItems.items.forEach(item => {
    const matchingProduct = productData.find(product => product.sku === item.item_id);
    if (!matchingProduct) return;
    const itm = item;
    itm.price = matchingProduct.price_range.maximum_price.final_price.value;
    newEcommItems.push(itm);
  });
  const ele = element;
  ele.dataset.ecommItems = JSON.stringify({
    items: newEcommItems
  });
};
let hasTrackedKlaviyoEvent = false;
let hasTrackedCriteoEvent = false;
const displayPricingAndButtons = productData => {
  productData.forEach(product => {
    if (product.price_range.maximum_price.final_price === undefined) return;
    const finalPrice = product.price_range.maximum_price.final_price.value;
    const compareAtPrice = product.price_range.maximum_price.regular_price.value;
    allPricingElements.forEach(ele => {
      if (ele.dataset.ecommSku !== product.sku) return;
      buildPricingElement(ele, product.price_range.maximum_price.final_price.value, product.price_range.maximum_price.regular_price.value);
      if (!Object(_availability__WEBPACK_IMPORTED_MODULE_4__["isAvailable"])(product)) return;
      const affirmPromo = product.affirm_product_promo_id;
      Object(_affirm__WEBPACK_IMPORTED_MODULE_1__["default"])(product.price_range.maximum_price.final_price.value, affirmPromo ? affirmPromo.value : '', ele);
    });

    if (!hasTrackedKlaviyoEvent) {
      hasTrackedKlaviyoEvent = true;
      const trackKlaviyoEvent = () => {
        const item = {
          ProductName: product.name || 'Unknown Product',
          ProductID: product.sku || 'Unknown ID',
          ImageURL: '',
          URL: window.location.href,
          Brand: product.brand || '',
          Price: finalPrice || '',
          CompareAtPrice: compareAtPrice || ''
        };
        console.log('Klaviyo is ready, tracking event:', item);
        window.klaviyo.push(['track', 'Viewed Product', item]);
      };
      const waitForKlaviyo = setInterval(() => {
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          clearInterval(waitForKlaviyo); 
          trackKlaviyoEvent();
        }
      }, 600); 
    }

    if (!hasTrackedCriteoEvent) {
      hasTrackedCriteoEvent = true;
      window.dataLayer = window.dataLayer || [];
      const criteoItem = {
        event: 'criteo_product',
        page_name: product.name || 'Unknown Product',
        page_url: window.location.href,
        user_logged_in: false,
        'criteo.ecommerce': {
          items: [{
            item_id: product.sku || 'Unknown ID'
          }]
        }
      };
      console.log('Criteo is ready, tracking event:', criteoItem);
      window.dataLayer.push(criteoItem);
    }
    allCardFlagElements.forEach(ele => {
      if (ele.dataset.ecommSku !== product.sku) return;
      if (ele.classList.contains('card-flag--overridden')) return;
      buildCardFlagElement(ele, product.price_range.maximum_price.final_price.value, product.price_range.maximum_price.regular_price.value);
    });
    allAtcButtonElements.forEach(ele => {
      if (ele.dataset.ecommSku !== product.sku) return;
      updateElementEcommItemsPricing(ele, productData);
      activateAtcButton(product, ele);
    });
    allAtcIconElements.forEach(ele => {
      if (ele.dataset.ecommSku !== product.sku) return;
      activateAtcIcons(product, ele);
    });
    allOosFormElements.forEach(ele => {
      if (ele.dataset.ecommSku !== product.sku) return;
      if (activateOosForm(product, ele)) initOosSignupUi(product, API.baseEcommerceUrl, API.baseApiUri, API.storeName);
    });
    buildAvailabilityElement(product);
  });
};
const displayBundlePricingAndButtons = productData => {
  let finalPrice;
  let basePrice;
  let finalPriceDisplay;
  let basePriceDisplay;
  let bundleIsPurchaseable;
  if (allBundles.length) {
    allBundles.forEach(bundle => {
      finalPrice = 0;
      basePrice = 0;
      finalPriceDisplay = 0;
      basePriceDisplay = 0;
      bundleIsPurchaseable = true;
      const parsedBundle = JSON.parse(bundle);
      parsedBundle.items.forEach((item, index) => {
        parsedBundle.items[index].foundInMagento = false;
        productData.forEach(product => {
          if (!bundleIsPurchaseable) return;
          if (product.price_range.maximum_price.final_price === undefined) return;
          if (item.item_id !== product.sku) return;
          parsedBundle.items[index].foundInMagento = true;
          if (!Object(_availability__WEBPACK_IMPORTED_MODULE_4__["isPurchaseable"])(product)) {
            bundleIsPurchaseable = false;
            return;
          }
          bundleIsPurchaseable = true;
          finalPrice += product.price_range.maximum_price.final_price.value * item.quantity;
          basePrice += product.price_range.maximum_price.regular_price.value * item.quantity;
        });
      }, parsedBundle);

      const incompleteBundleInfo = parsedBundle.items.find(o => o.foundInMagento === false);
      if (incompleteBundleInfo) {
        bundleIsPurchaseable = false;
      }
      finalPriceDisplay = parseFloat(finalPrice);
      basePriceDisplay = parseFloat(basePrice);
      if (!bundleIsPurchaseable || finalPriceDisplay === 0) return;
      allPricingElements.forEach(ele => {
        if (ele.dataset.ecommItems !== bundle) return;
        const pricingEle = ele;
        buildPricingElement(pricingEle, finalPriceDisplay, basePriceDisplay);
        Object(_affirm__WEBPACK_IMPORTED_MODULE_1__["default"])(finalPriceDisplay, '', pricingEle);
      });
      allCardFlagElements.forEach(ele => {
        if (ele.dataset.ecommItems !== bundle) return;
        if (ele.classList.contains('card-flag--overridden')) return;
        buildCardFlagElement(ele, finalPriceDisplay, basePriceDisplay);
      });
      allAtcButtonElements.forEach(ele => {
        if (ele.dataset.ecommItems !== bundle) return;
        updateElementEcommItemsPricing(ele, productData);
        activateAtcButton(undefined, ele);
      });
      allAtcIconElements.forEach(ele => {
        if (ele.dataset.ecommItems !== bundle) return;
        activateAtcIcons(undefined, ele);
      });
    });
  }
};

const toggleProductCardForRefurbished = productData => {
  productData.forEach(product => {
    if (product.price_range.maximum_price.final_price === undefined) return;
    allPricingElements.forEach(ele => {
      if (ele.dataset.ecommSku !== product.sku) return;
      const parentCard = ele.closest('.product-card');
      if (parentCard === null || !parentCard.classList.contains('is-refurbished')) return;
      if (!Object(_availability__WEBPACK_IMPORTED_MODULE_4__["isAvailable"])(product)) return;
      parentCard.style.display = 'block';
    });
  });
};
const loadAndDisplayPricing = api => {
  if (uniqueSkus.length === 0) return;
  let productData;
  API = api;
  api.getProductInfo(uniqueSkus).then(data => {
    productData = data.data.products.items;

    toggleProductCardForRefurbished(productData);


    displayPricingAndButtons(productData);

    displayBundlePricingAndButtons(productData);

    Object(_placeholder__WEBPACK_IMPORTED_MODULE_3__["default"])();
  }).catch(error => {
    console.warn(error);
  });
};

 }),

 106:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "numberToDollarString", function() { return numberToDollarString; });
 __webpack_require__.d(__webpack_exports__, "dollarsToCents", function() { return dollarsToCents; });
const addCommas = number => {
  const nStr = "".concat(number);
  const x = nStr.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? ".".concat(x[1]) : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
};

const numberToDollarString = number => {
  const curr = number.toFixed(2);
  return "$".concat(addCommas(curr));
};

const dollarsToCents = value => {
  let val = "".concat(value).replace(/[^\d.-]/g, '');
  if (val && val.includes('.')) {
    val = val.substring(0, val.indexOf('.') + 3);
  }
  return val ? Math.round(parseFloat(val) * 100) : 0;
};

 }),

 107:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "default", function() { return injectAffirmMonthlyPmtMessaging; });
 var _currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);



function injectAffirmMonthlyPmtMessaging(price, promoId, wrapperElement) {
  if (typeof affirm === 'undefined') return;
  const exists = wrapperElement.querySelectorAll('.affirm-as-low-as').length;
  if (exists) return;
  const eleAffirmAsLowAs = document.createElement('p');
  eleAffirmAsLowAs.setAttribute('class', 'affirm-as-low-as');
  eleAffirmAsLowAs.dataset.pageType = 'product';
  eleAffirmAsLowAs.dataset.affirmColor = 'white';
  eleAffirmAsLowAs.dataset.amount = Object(_currency__WEBPACK_IMPORTED_MODULE_0__["dollarsToCents"])(price);
  eleAffirmAsLowAs.dataset.promoId = promoId;
  wrapperElement.append(eleAffirmAsLowAs);
  affirm.ui.ready(() => {
    affirm.ui.refresh();
  });
}

 }),

 108:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "default", function() { return initSignupUi; });

const status = response => {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  }
  return Promise.reject(new Error(response.statusText));
};
const json = response => {
  return response.json();
};
const signupSuccess = (formElement, messageElement) => {
  const formEle = formElement;
  const msgEle = messageElement;

  formEle.style.display = 'none';

  msgEle.style.display = 'block';
  msgEle.innerHTML = '<p>Thank you! You will be notified via email when this product is in stock.</p>';
};
const submitSignup = (options, callback) => {
  const reqData = options.data;
  const fullApiUrl = "".concat(options.baseEcommerceUrl).concat(options.baseApiUri);
  const reqUrl = new URL("".concat(fullApiUrl));

  return fetch(reqUrl, {
    method: 'POST',
    credentials: 'include',
    headers: [['Content-Type', 'application/json'], ['Store', options.storeName]],
    body: JSON.stringify({
      query: "\n          mutation {\n            createStockAlert(\n              input:{\n                sku: \"".concat(reqData.sku, "\"\n                email: \"").concat(reqData.guest_email, "\"\n              }\n            ){\n              status,\n              message\n            }\n          }\n        ")
    })
  }).then(status).then(json).then(responseData => {
  }).catch(error => console.warn(error));
};

function initSignupUi(options) {
  const ui = document.querySelectorAll("*[id^=\"".concat(options.eleId, "\"]"));
  if (ui.length > 0) {
    ui[0].classList.add('js-oos-form-wrapper--oos');
    ui[0].classList.add('oos-notify--active');

    const formEle = ui[0].querySelector('.js-oos-notify-form');
    const msgEle = ui[0].querySelector('.js-oos-notify-msg');
    formEle.addEventListener('submit', event => {
      event.preventDefault();
      const formData = Object.values(formEle).reduce((obj, field) => {
        const ob = obj;
        ob[field.name] = field.value;
        return ob;
      }, {});
      const ajaxOptions = {
        data: formData,
        baseEcommerceUrl: options.baseEcommerceUrl,
        baseApiUri: options.baseApiUri,
        storeName: options.storeName
      };
      const submitButtonEle = formEle.querySelector('button');
      if (submitButtonEle) {
        submitButtonEle.setAttribute('disabled', 'disabled');
        submitButtonEle.innerHTML = '(submitting...)';
      }
      submitSignup(ajaxOptions).then(data => {
        signupSuccess(formEle, msgEle);
      });
    });
  }
}

 }),

 109:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "default", function() { return removePlaceholderClasses; });

function removePlaceholderClasses() {
  const cardPricingPlaceholders = document.querySelectorAll('.product-card__pricing-wrapper--placeholder');
  cardPricingPlaceholders.forEach(ele => {
    ele.classList.remove('product-card__pricing-wrapper--placeholder');
    ele.classList.remove('effect--shimmer');
  });
  const cardAtcPlaceholders = document.querySelectorAll('.product-card__atc-wrapper--placeholder');
  cardAtcPlaceholders.forEach(ele => {
    ele.classList.remove('product-card__atc-wrapper--placeholder');
    ele.classList.remove('effect--shimmer');
  });
  const pdpPricingPlaceholders = document.querySelectorAll('.product-info-pricing--placeholder');
  pdpPricingPlaceholders.forEach(ele => {
    ele.classList.remove('product-info-pricing--placeholder');
    ele.classList.remove('effect--shimmer');
  });
  const pdpAtcPlaceholders = document.querySelectorAll('.atc-wrapper--placeholder');
  pdpAtcPlaceholders.forEach(ele => {
    ele.classList.remove('atc-wrapper--placeholder');
    ele.classList.remove('effect--shimmer');
  });
}

 }),

 110:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "isAvailable", function() { return isAvailable; });
 __webpack_require__.d(__webpack_exports__, "isOnPreorder", function() { return isOnPreorder; });
 __webpack_require__.d(__webpack_exports__, "isOnBackorder", function() { return isOnBackorder; });
 __webpack_require__.d(__webpack_exports__, "isOutOfStock", function() { return isOutOfStock; });
 __webpack_require__.d(__webpack_exports__, "isPurchaseable", function() { return isPurchaseable; });
 __webpack_require__.d(__webpack_exports__, "showAvailText", function() { return showAvailText; });

const isAvailable = product => {
  return product.stock_status === 'IN_STOCK' && (product.is_pre_order === 0 || product.is_pre_order === null) && product.sqty > 0;
};

const isOnPreorder = product => {
  return product.stock_status === 'IN_STOCK' && product.is_pre_order === 1 && product.sqty > 0;
};

const isOnBackorder = product => {
  return product.stock_status === 'IN_STOCK' && (product.is_pre_order === 0 || product.is_pre_order === null) && product.backorder_status && product.sqty <= 0;
};

const isOutOfStock = product => {
  return product.stock_status === 'OUT_OF_STOCK';
};

const isPurchaseable = product => {
  return isAvailable(product) || isOnBackorder(product) || isOnPreorder(product);
};

const showAvailText = product => {
  if (isOnPreorder(product)) return product.pre_order_label;
  if (isAvailable(product) && product.sqty) {
    if (product.sqty < 5) return '<em>(Less than 5 in stock)</em>';
    if (product.sqty < 10) return '<em>(Less than 10 in stock)</em>';
    return '';
  }
  if (isOnBackorder(product)) return 'Temporarily Out of Stock. Available for Backorder.';
  if (isOutOfStock(product)) return 'Out of Stock.';
  return '';
};

 }),

 111:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "default", function() { return initAtc; });
 var _pepperjam__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(112);
 var _facebook__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(114);
 var _analytics_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(115);



let API;
let currentCart;
let cartData;
let cartQty = 0;
const headerCartLink = document.getElementById('goto-cart');

const displayCartQty = qty => {
  const counterEle = document.querySelector('#cart-item-counter');
  if (!counterEle) return;
  if (qty > 0) {
    counterEle.innerHTML = qty;
    counterEle.style.display = 'block';
    return;
  }
  counterEle.style.display = 'none';
};

const addToCart = (items, callback) => {
  cartData = API.cartData;
  const cartId = cartData.id;
  const reqData = items;

  API.addToCart(reqData, cartId).then(data => {
    currentCart = API.currentCart;
    if (currentCart.errors !== undefined) {
      Array.from(currentCart.errors).forEach(error => {
        console.log("error: ".concat(error.message));
        const message = document.querySelector('.js-atc-message');
        const btns = document.getElementsByClassName('add-to-cart-button');
        for (const btn of btns) {
          btn.innerHTML = 'Add to Cart';
        }
        message.innerHTML = error.message;
        message.style.display = 'block';
      });
    } else {
      cartQty = 0;
      cartData = API.cartData;
      cartData.items.forEach(itemData => {
        cartQty += itemData.quantity;
      });
      displayCartQty(cartQty);

      if (callback) {
        callback();
      }
    }
  }).catch(error => {
    console.warn(error);
  });
};
const buildPartsToAddFromBundles = (bundleComponents, quantity) => {
  const partsToAdd = [];
  bundleComponents.items.forEach(data => {
    if (data.omitFromAtc !== null && data.omitFromAtc !== 1) {
      partsToAdd.push({
        data: {
          sku: data.item_id,
          quantity: parseFloat(data.quantity * quantity)
        }
      });
    }
    Object(_facebook__WEBPACK_IMPORTED_MODULE_1__["default"])(data.item_id);
  });
  return partsToAdd;
};
const buildPartsToAdd = (partNumber, quantity) => {
  const partsToAdd = [];
  const toAdd = {
    data: {
      sku: partNumber,
      quantity: parseFloat(quantity)
    }
  };


  partsToAdd.push(toAdd);
  Object(_facebook__WEBPACK_IMPORTED_MODULE_1__["default"])(partNumber);
  return partsToAdd;
};

const handleAtcButtonClick = button => {
  const btn = button;
  const closestAtcButtonFormWrapper = btn.closest('.js-atc-form-wrapper');
  const quantity = closestAtcButtonFormWrapper.querySelector('.js-atc-form-qty').value;
  const partNumber = btn.dataset.ecommSku;
  const bundleComponents = btn.dataset.ecommBundle ? JSON.parse(btn.dataset.ecommItems) : '';
  const cartLink = closestAtcButtonFormWrapper.querySelector('.js-atc-link');
  const atcMessage = closestAtcButtonFormWrapper.querySelector('.js-atc-message');


  btn.disabled = true;
  btn.innerHTML = '(ADDING TO CART)';
  atcMessage.innerHTML = '';
  let partsToAdd = buildPartsToAdd(partNumber, quantity);

  if (bundleComponents !== undefined && bundleComponents.length !== 0) partsToAdd = buildPartsToAddFromBundles(bundleComponents, quantity);
  addToCart(partsToAdd, () => {
    btn.innerHTML = 'PRODUCT ADDED';
    btn.classList.add('atc-button-success');
    const cartLink = btn.nextElementSibling.querySelector('.atc-button-cart-link');

    let cartUrl = "".concat(API.baseEcommerceUrl, "checkout/cart");
    cartUrl = Object(_pepperjam__WEBPACK_IMPORTED_MODULE_0__["default"])(cartUrl);
    cartLink.querySelector('a').href = cartUrl;
    headerCartLink.href = cartUrl;
    cartLink.style.display = 'block';

    Object(_analytics_events__WEBPACK_IMPORTED_MODULE_2__["trackAddToCart"])(btn.dataset.ecommItems, quantity, API.currency);
  });
};

const getCart = callback => {
  let cartUrl;

  API.getCart().then(data => {
    currentCart = API.currentCart;
    cartData = API.cartData;
    cartData.items.forEach(itemData => {
      cartQty += itemData.quantity;
    });

    cartUrl = "".concat(API.baseEcommerceUrl, "checkout/cart");
    if (cartUrl !== '') {
      cartUrl = Object(_pepperjam__WEBPACK_IMPORTED_MODULE_0__["default"])(cartUrl);
      headerCartLink.href = cartUrl;
    }
    displayCartQty(cartQty);

    if (callback) {
      callback();
    }
  }).catch(error => {
    console.warn(error);
  });
};
function initAtc(api) {
  API = api;
  getCart();
}

document.addEventListener('click', event => {
  if (event.target.matches('.js-atc-button') && window.__klipsch.magentoVersion === '2.4') {
    handleAtcButtonClick(event.target);
  }
}, {
  passive: true
});

 }),

 112:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "default", function() { return persistPepperjamCartId; });
 var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(113);


function persistPepperjamCartId(url) {
  const clickIdParamName = 'clickId';
  const clickIdParamVal = Object(_helpers__WEBPACK_IMPORTED_MODULE_0__["getParameterByName"])(clickIdParamName);
  let retUrl = url;
  if (clickIdParamVal !== undefined) {
    if (retUrl) {
      retUrl = Object(_helpers__WEBPACK_IMPORTED_MODULE_0__["updateUrlParameter"])(url, clickIdParamName, clickIdParamVal);
    }
  }
  return retUrl;
}

 }),

 113:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "getParameterByName", function() { return getParameterByName; });
 __webpack_require__.d(__webpack_exports__, "updateUrlParameter", function() { return updateUrlParameter; });
const getParams = url => {
  const params = {};
  const parser = document.createElement('a');
  parser.href = url;
  const query = parser.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
};
const getParameterByName = name => {
  const params = getParams(window.location.href);
  return params[name];
};

const updateUrlParameter = (uri, key, value) => {
  const i = uri.indexOf('#');
  const hash = i === -1 ? '' : uri.substr(i);
  let retUri = i === -1 ? uri : uri.substr(0, i);
  const re = new RegExp("([?&])".concat(key, "=.*?(&|$)"), 'i');
  const separator = retUri.indexOf('?') !== -1 ? '&' : '?';
  if (retUri.match(re)) {
    retUri = retUri.replace(re, "$1".concat(key, "=").concat(value, "$2"));
  } else {
    retUri = "".concat(retUri + separator + key, "=").concat(value);
  }
  return retUri + hash; 
};

 }),

 114:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "default", function() { return facebookTrackAddToCart; });

function facebookTrackAddToCart(partNumber) {
  if (typeof fbq === 'undefined') return;
  fbq('track', 'AddToCart', {
    content_ids: [partNumber],
    content_type: 'product'
  });
}

 }),

 115:
 (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
 __webpack_require__.d(__webpack_exports__, "trackAddToCart", function() { return trackAddToCart; });
 __webpack_require__.d(__webpack_exports__, "trackViewItemList", function() { return trackViewItemList; });
 __webpack_require__.d(__webpack_exports__, "trackSelectItem", function() { return trackSelectItem; });
 __webpack_require__.d(__webpack_exports__, "trackViewItem", function() { return trackViewItem; });

const initDataLayerObject = () => {
  window.dataLayer = window.dataLayer || [];
};

const setupItemsToTrack = function (itemsAdded) {
  let currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  let quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const itemsToTrack = [];
  itemsAdded.items.forEach(itm => {
    const item = itm;
    item.currency = currency;
    if (quantity !== null) {
      const qty = item.quantity * quantity;
      item.quantity = qty;
    }
    itemsToTrack.push(item);
  });
  return itemsToTrack;
};

const clearEcommerceObject = () => {
  window.dataLayer.push({
    ecommerce: null
  });
};

const trackAddToCart = (ecommItems, quantity, currency) => {
  initDataLayerObject();
  clearEcommerceObject();
  const itemsAdded = JSON.parse(ecommItems);
  const itemsToTrack = setupItemsToTrack(itemsAdded, currency, quantity);
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      items: itemsToTrack
    }
  });
};

const trackViewItemList = function (ecommItemsList) {
  let currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  initDataLayerObject();
  clearEcommerceObject();
  const itemsAdded = JSON.parse(ecommItemsList);
  const itemsToTrack = setupItemsToTrack(itemsAdded, currency);
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      item_list_name: itemsAdded.item_list_name,
      items: itemsToTrack
    }
  });
};

const trackSelectItem = function (ecommItemsList) {
  let currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  initDataLayerObject();
  clearEcommerceObject();
  const itemsAdded = JSON.parse(ecommItemsList);
  const itemsToTrack = setupItemsToTrack(itemsAdded, currency);
  window.dataLayer.push({
    event: 'select_item',
    ecommerce: {
      items: itemsToTrack
    }
  });
};

const trackViewItem = function (ecommItemsList) {
  let currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  initDataLayerObject();
  clearEcommerceObject();
  const itemsAdded = JSON.parse(ecommItemsList);
  const itemsToTrack = setupItemsToTrack(itemsAdded, currency);
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      items: itemsToTrack
    },
    currency
  });
};

 })

 });